<ng-container *ngFor="let property of properties">
    <cw-property-group *ngIf="isVisibleGroup(property)" [propertySet]="propertySet" [property]="property"
        [catalogObject]="catalogObject">
    </cw-property-group>

    <div [hidden]="!isVisible(property)">
        <cw-property-color *ngIf="isColor(property)" [propertySet]="propertySet" [property]="property">
        </cw-property-color>

        <cw-property-checkbox *ngIf="isBoolean(property)" [propertySet]="propertySet" [property]="property">
        </cw-property-checkbox>

        <cw-property-toggle *ngIf="isToggle(property)" [propertySet]="propertySet" [property]="property">
        </cw-property-toggle>

        <cw-property-number *ngIf="isNumber(property)" [propertySet]="propertySet" [property]="property">
        </cw-property-number>

        <cw-property-select *ngIf="isSelect(property)" [propertySet]="propertySet" [property]="property">
        </cw-property-select>

        <cw-property-text *ngIf="isText(property)" [propertySet]="propertySet" [property]="property">
        </cw-property-text>

        <cw-property-point *ngIf="isPoint(property)" [propertySet]="propertySet" [property]="property">
        </cw-property-point>

        <cw-property-point-array *ngIf="isPointArray(property)" [propertySet]="propertySet" [property]="property">
        </cw-property-point-array>

        <cw-property-expression *ngIf="isExpression(property)" [propertySet]="propertySet" [property]="property">
        </cw-property-expression>

        <cw-property-switch *ngIf="isSwitch(property)" [propertySet]="propertySet" [property]="property">
        </cw-property-switch>

        <cw-property-classification *ngIf="isClassification(property)" [propertySet]="propertySet"
            [property]="property">
        </cw-property-classification>
    </div>
</ng-container>